import React from 'react'
import { csx } from '@vtex/admin-ui'

export type ProductCarouselDescriptionProps = React.ComponentProps<'p'>

export const ProductCarouselDescription = (
  props: ProductCarouselDescriptionProps
) => (
  <p
    className={csx({
      text: '$detail',
      color: '$gray40',
      '@desktop': {
        text: '$body',
      },
    })}
    {...props}
  />
)
